// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.overview-chart[data-v-3a621865] {\n  padding: 0;\n}\n.badge[data-v-3a621865] {\n  margin-right: 0.4rem;\n}\n.dropdown-menu[data-v-3a621865] {\n  max-height: 30rem;\n  overflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
